import locale from './locale';

const message = {
  ja: {
    testResult: 'テスト結果',
    scoreDistribution: 'スコア分布',
    score: 'スコア',
    numOfStudents: '人数',
    months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    learnTimeVsTestScore: '学習時間とテストスコアの関係',
    learnTimeHour: '学習時間（時間）',
    hour: '時間',
    average: '平均',
    max: '最高',
    min: '最低',
    learnTimeDistribution: '学習時間分布',
    completionRate: '完了率',
    className: 'クラス',
    testScoreByClass: 'テストスコア（クラス別）',
    averageScoreLatest: '平均スコア（最新）',
    chartErrorMessage: '1人以上が受験済みのテストを集計しないと、Chartは表示されません。',
    date: '日付',
    dateRange: '期間',
    lastWeek: '先週',
    lastMonth: '先月',
    last7Days: '過去 7日間',
    last30Days: '過去 30日間',
    last1Year: '過去 1年間',
    apply: '適用',
    cancel: 'キャンセル',
    allTimeSelect: '全期間を選択',
    mileage: 'マイレージ',
    mile: 'マイル',
    learnTime: '学習時間',
    vocabulary: '単語',
    grammar: '文法',
    listening: 'リスニング',
    reading: 'リーディング',
    words: '語',
    meaning: '意味',
    spelling: 'スペル',
    showSearchCriteria: '検索条件を表示する',
    hideSearchCriteria: '検索条件を隠す',
    numberOfKnownWords: '知ってる単語数',
    total: '総合',
    numberOfWords: '単語数',
    comparedToThePreviousDay: '前日との差',
    selectQuiz: '問題集選択',
    assignStudents: '受講者アサイン',
    delete: '削除します。',
    isItOK: 'よろしいですか？',
    deleteDistributionSet: '配信セットを削除します。',
    deleteOriginalTestDistributionSet: 'オリジナルテスト配信セットを削除します。',
    resetPassword: 'パスワードをリセットします。',
    passwordChanged: 'パスワードを変更しました。',
    tellStudentPassword: 'パスワードをメモして生徒へお伝え下さい。',
    passwordResetError: 'パスワードリセット処理を失敗しました。',
    resetParentsPassword: '保護者のパスワードをリセットします。',
    tellParentsPassword: 'パスワードをメモして保護者へお伝え下さい。',
    addingToList: 'リストに追加中…',
    selectStudents: '受講者を選択してください。',
    notSelectedAddStudents: '追加する受講者が選択されていません。',
    checkAddStudentsTab: '「追加する受講者」タブをご確認ください。',
    notSelectedCancelStudents: '解除する受講者が選択されていません。',
    checkCancelStudentsTab: '「解除する受講者」タブをご確認ください。',
    upTo1000: '同時に処理できる件数は1000件までとなっています。',
    selectOrRefine: '受講者を選択するか、もしくは、検索条件を絞り込んで再検索してください。',
  },
  en: {
    testResult: 'Test Results',
    scoreDistribution: 'Score Distribution',
    score: 'score',
    numOfStudents: 'Num of Students',
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    learnTimeVsTestScore: 'Learn Time vs. Test Score',
    learnTimeHour: 'Learn Time (hr)',
    hour: 'hr',
    average: 'Avg.',
    max: 'Max',
    min: 'Min',
    learnTimeDistribution: 'Learn Time Distribution',
    completionRate: 'Completion Rate',
    className: 'Class',
    testScoreByClass: 'Test Score (By Class)',
    averageScoreLatest: 'Score Avg. (latest)',
    chartErrorMessage: 'The chart is not shown. Please select the test that has been taken.',
    date: 'Date',
    dateRange: 'Range',
    lastWeek: 'last wk.',
    lastMonth: 'last mo.',
    last7Days: '7 days',
    last30Days: '30 days',
    last1Year: '1 yr.',
    apply: 'Apply',
    cancel: 'Cancel',
    allTimeSelect: 'All Time',
    mileage: 'Mileage',
    mile: 'mile(s)',
    learnTime: 'Learn Time',
    vocabulary: 'Vocabulary',
    grammar: 'Grammar',
    listening: 'Listening',
    reading: 'Reading',
    words: 'word(s)',
    meaning: 'Meaning',
    spelling: 'Spelling',
    showSearchCriteria: 'Show Search Criteria',
    hideSearchCriteria: 'Hide Search Criteria',
    numberOfKnownWords: 'Num of Known Words',
    total: 'Total',
    numberOfWords: 'Words',
    comparedToThePreviousDay: 'Compared to the previous day',
    selectQuiz: 'Select Quiz.',
    assignStudents: 'Assign Students',
    delete: 'Delete.',
    isItOK: 'Is it OK?',
    deleteDistributionSet: 'Delete the Distribution Set.',
    deleteOriginalTestDistributionSet: 'Delete the Original Test Distribution Set.',
    resetPassword: 'Reset password.',
    passwordChanged: 'Password changed.',
    tellStudentPassword: 'Tell the password to the student.',
    passwordResetError: 'Password Reset Error',
    resetParentsPassword: "Reset parents' password.",
    tellParentsPassword: 'Tell the password to the parents.',
    addingToList: 'Adding to list...',
    selectStudents: 'Select students.',
    notSelectedAddStudents: "Students to add aren't selected.",
    checkAddStudentsTab: 'Please check on 「Students to add」 tab.',
    notSelectedCancelStudents: "Students to cancel aren't selected.",
    checkCancelStudentsTab: 'Please check on 「Students to cancel」 tab.',
    upTo1000: 'The number of students that can be processed is limited to 1000 at a time.',
    selectOrRefine: 'Please select students or refine your search criteria and search again.',
  },
};

export default message[locale];



// WEBPACK FOOTER //
// ./es6/utils/message.js